import * as React from 'react';
import { Provider } from 'react-redux';
import { ApolloProvider } from '@apollo/react-hooks';
import { useGraphQLClient } from '../../graphql-client';
import FlightStatusBase from './components/FlightStatus/FlightStatus';
import { initI18n } from '../../utils';
import { createStore } from './store';
import ExternalLocaleResources from '../../ExternalLocaleResources/ExternalLocaleResources';
import { bootstrap } from '@shared/lib/Bootstrap/bootstrap';
import { useConfig } from '../../context';
initI18n('FlightStatus');
const FlightStatus = () => {
    const client = useGraphQLClient();
    const store = createStore();
    bootstrap(useConfig());
    return (React.createElement(ApolloProvider, { client: client },
        React.createElement(Provider, { store: store },
            React.createElement(ExternalLocaleResources, null),
            React.createElement(FlightStatusBase, null))));
};
export default FlightStatus;
